import { ImageTransformOptions, ImageTransformType } from '@diritto/common/imageKit/constants';
import { InboxNotiDto } from '@diritto/common/notification/dtos/inbox-noti.dto';
import { Color } from '@diritto/common/style/color';
import { Typography } from '@diritto/common/style/typography';
import { convertToDotString, convertToRelativeString } from '@diritto/common/utils/date';
import styled from '@emotion/styled';
import { ContentDescriptionRowCount } from 'constants/content';
import * as Styled from 'app-components/inbox/items/styles';
import { getTextLineStyle } from 'styles/common';
import { Divider } from 'ui-components/common/Divider';
import { Link } from 'ui-components/common/Link';
import { IkImage } from 'ui-components/Imagekit/IkImage';
import { ContentPublicRelayDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { useState } from 'react';

interface ContentInboxNotiListItemProps {
  inboxNoti: InboxNotiDto;
  content?: ContentPublicRelayDto;
}

export const ContentInboxNotiListItem = ({ inboxNoti, content }: ContentInboxNotiListItemProps) => {
  const [isRead] = useState(inboxNoti.isRead);

  if (!content) {
    return null;
  }

  return (
    <Link href={`contents/${content.id}`}>
      <Styled.Container>
        <Styled.LeftCoverSection>
          <Styled.Unread isRead={isRead} />
          <Styled.CoverWrapper>
            <IkImage
              transform={{
                path: content.cover.path,
                isPrivate: content.cover.isPrivate,
                transformation: ImageTransformOptions[ImageTransformType.Inbox],
              }}
              alt={`${inboxNoti.title} 표지`}
            />
          </Styled.CoverWrapper>
        </Styled.LeftCoverSection>
        <Styled.RightSection>
          <Styled.TitleWrapper>
            <Styled.SanitizeHTMLTitle
              html={`${inboxNoti.title}<span class="inbox-title-date" title="${convertToDotString(
                inboxNoti.sentAt,
              )}">${convertToRelativeString(inboxNoti.sentAt)}</span>`}
              options={{
                allowedTags: ['b', 'span'],
                allowedClasses: {
                  span: ['inbox-title-date'],
                },
                allowedAttributes: { span: ['title'] },
              }}
            />
          </Styled.TitleWrapper>
          <Styled.Extra>
            <StyledContentDesc>{content.description}</StyledContentDesc>
          </Styled.Extra>
        </Styled.RightSection>
        <Divider color={Color.Gray200} />
      </Styled.Container>
    </Link>
  );
};

const StyledContentDesc = styled.p`
  ${Typography.XXSmall}
  ${getTextLineStyle(ContentDescriptionRowCount)};
  color: ${Color.Gray600};
`;
